import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api.js';

export type EmailSenderSettings = {
  sender_name: string | null;
  reply_to: string | null;
  /** Read-only: the shared verified address every pilot email is sent from. */
  shared_from_address: string;
};

export type UpdateEmailSenderPayload = {
  sender_name?: string;
  reply_to?: string;
};

export function useEmailSender() {
  return useQuery({
    queryKey: ['admin', 'email-sender'],
    queryFn: () => apiGet<EmailSenderSettings>('/admin/email-sender'),
    staleTime: 30_000,
  });
}

export function useUpdateEmailSender() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateEmailSenderPayload) =>
      apiPatch<EmailSenderSettings>('/admin/email-sender', input),
    onSuccess: (data) => qc.setQueryData(['admin', 'email-sender'], data),
  });
}
